import { LoadScriptNext } from '@react-google-maps/api';
import { Outlet } from 'react-router';

const GOOGLE_PLACES_API_KEY = import.meta.env.VITE_GOOGLE_PLACES_API_KEY;
const libraries: 'places'[] = ['places'];

const MainLayout = () => {
  return (
    <LoadScriptNext googleMapsApiKey={GOOGLE_PLACES_API_KEY} libraries={libraries}>
      <div className="auth-page-wrap bg-auth-bg">
        <Outlet />
      </div>
    </LoadScriptNext>
  );
};

export default MainLayout;
